/* 07 · ANY 5 JARS SHIP FREE — sections/nhp-home-07-collection.liquid. Rebuilt 2026-09-22.
   Tap a jar to take it out / put it back; − / + for more (capped at real stock). Every jar picked stands in
   Jay's crate. When the order (what's already in the cart + the picks) clears the free-shipping line, Jay's
   FREE SHIPPING stamp SLAMS onto the crate: the site's lightning, a jolt, dust off both sides.
   The first time the section comes into view the crate starts empty and the picks drop in one by one — the
   stamp slams on the way, so everyone sees it once. One button adds every pick in one request and opens the
   cart; on phones a pinned bar carries the same button while the crate's is off screen. */
(function () {
  var root = document.querySelector('[data-nhp-coll]');
  if (!root) return;
  var reduce = matchMedia('(prefers-reduced-motion: reduce)').matches;
  var html = document.documentElement;
  var jars = [].slice.call(root.querySelectorAll('[data-nhp-pick]'));
  var btn = root.querySelector('[data-nhp-coll-add]');
  var crate = root.querySelector('[data-nhp-crate]');
  var slots = root.querySelector('[data-nhp-slots]');
  var more = root.querySelector('[data-nhp-more]');
  var msg = root.querySelector('[data-nhp-coll-msg]');
  var bar = root.querySelector('[data-nhp-coll-bar]');
  var barBtn = root.querySelector('[data-nhp-bar-add]');
  var barCount = root.querySelector('[data-nhp-bar-count]');
  var T = Number(root.getAttribute('data-threshold')) || 0;
  var inCart = Number(root.getAttribute('data-cart')) || 0;
  var AWAY = root.getAttribute('data-away') || '[AMOUNT] MORE TO FREE SHIPPING';
  var UNLOCKED = root.getAttribute('data-unlocked') || 'FREE SHIPPING UNLOCKED';
  var CTA = root.getAttribute('data-cta') || 'ADD [N] TO CART';
  var NONE = root.getAttribute('data-none') || 'PICK A JAR';
  var CARTFREE = root.getAttribute('data-cartfree') || "FREE SHIPPING WITH WHAT'S ALREADY IN YOUR CART";
  var fmt = root.getAttribute('data-money') || '${{amount}}';
  var SLOTS = 5;           // the crate holds five — "ANY 5 JARS": a full crate ships free. More show as +N
  var busy = false;
  var shown = reduce ? Infinity : 0;   // how many picks are in the crate — grows during the intro, then follows
  var stamped = null;      // is the stamp on the crate right now (null = not decided yet)

  function money(cents) {
    var n = (cents / 100).toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ',');
    return fmt.replace(/\{\{\s*amount[a-z_]*\s*\}\}/, n);
  }
  function qty(li) { return Number(li.getAttribute('data-qty')) || 0; }
  function src(li) { var i = li.querySelector('.nhp-coll__img'); return i ? (i.currentSrc || i.src) : ''; }

  /* every picked jar as one unit, in shelf order */
  function units() {
    var u = [];
    jars.forEach(function (li) {
      for (var k = 0; k < qty(li); k++) u.push({ li: li, price: Number(li.getAttribute('data-price')) || 0 });
    });
    return u;
  }

  /* ---- the lightning + the stamp ---- */
  function strike() {
    if (reduce) return;
    html.style.setProperty('--si', '0.9');
    var hit = function (on) { html.classList.toggle('nhp-strike', on); root.classList.toggle('is-strike', on); };
    hit(true);
    setTimeout(function () { hit(false); }, 90);
    setTimeout(function () { hit(true); }, 200);
    setTimeout(function () { hit(false); html.style.removeProperty('--si'); }, 320);
  }
  function stamp(on, animate) {
    if (on === stamped) return;
    stamped = on;
    crate.classList.remove('is-slam', 'is-lift');
    void crate.offsetWidth;
    crate.classList.toggle('is-stamped', on);
    if (!animate || reduce) return;
    if (on) { crate.classList.add('is-slam'); setTimeout(strike, 120); }
    else crate.classList.add('is-lift');
  }

  /* ---- draw ---- */
  var drawn = [];   // the <img>s standing in the crate, one per unit
  function draw(animateNew) {
    var u = units();
    var n = Math.min(u.length, shown);
    var vis = Math.min(n, SLOTS);
    while (drawn.length > vis) {
      var gone = drawn.pop();
      gone.classList.add('is-leaving');
      (function (el) { setTimeout(function () { el.remove(); }, reduce ? 0 : 260); })(gone);
    }
    for (var i = 0; i < vis; i++) {
      var s = src(u[i].li);
      if (drawn[i]) { if (drawn[i].getAttribute('src') !== s) drawn[i].src = s; continue; }
      var img = document.createElement('img');
      img.className = 'nhp-coll__unit' + (animateNew && !reduce ? ' is-dropping' : '');
      img.alt = '';
      img.src = s;
      slots.appendChild(img);
      drawn.push(img);
      if (animateNew && !reduce) { crate.classList.remove('is-thud'); void crate.offsetWidth; crate.classList.add('is-thud'); }
    }
    more.textContent = n > SLOTS ? '+' + (n - SLOTS) : '';

    // the stamp follows what's IN the crate (+ the cart), so during the intro it lands on the right jar
    var cents = 0;
    for (var k = 0; k < n; k++) cents += u[k].price;
    var total = inCart + cents;
    var free = T > 0 && total >= T;
    stamp(free, animateNew);
    if (msg && shown !== Infinity && !free) msg.innerHTML = '';   // mid-intro the crate is still filling — no "$65 to go" while six are picked
    else if (msg) {
      /* the crate alone doesn't clear the line but the cart tips it over — say so, or the stamp looks wrong (Jay) */
      var viaCart = free && inCart > 0 && cents < T;
      msg.classList.toggle('is-free', free && !viaCart);
      msg.innerHTML = viaCart ? CARTFREE
        : free ? '<span class="nhp-sr">' + UNLOCKED + '</span>'
        : AWAY.replace('[AMOUNT]', '<strong>' + money(T - total) + '</strong>');
    }

    // the buttons always count EVERY pick (the intro only delays the crate, never the price)
    var all = u.length, allCents = 0;
    u.forEach(function (x) { allCents += x.price; });
    if (!busy) {
      btn.textContent = all ? CTA.replace('[N]', all) + ' · ' + money(allCents) : NONE;
      btn.disabled = all === 0;
      if (barBtn) { barBtn.textContent = all ? CTA.replace('[N]', all) : NONE; barBtn.disabled = all === 0; }
    }
    if (barCount) {
      var left = T - inCart - allCents;
      barCount.innerHTML = !T ? money(allCents)
        : left <= 0 ? '<strong>SHIPS FREE</strong> · ' + money(allCents)
        : '<strong>' + money(left) + '</strong> TO FREE SHIPPING';
    }
  }

  function setQty(li, q, quiet) {
    var max = Number(li.getAttribute('data-max')) || 0;
    q = Math.max(0, Math.min(max, q));
    li.setAttribute('data-qty', q);
    li.classList.toggle('is-picked', q > 0);
    var t = li.querySelector('[data-nhp-toggle]');
    if (t) t.setAttribute('aria-pressed', q > 0 ? 'true' : 'false');
    var out = li.querySelector('[data-nhp-n]');
    if (out) out.textContent = q;
    var steps = li.querySelectorAll('[data-nhp-step]');
    if (steps[0]) steps[0].disabled = q <= 0;
    if (steps[1]) steps[1].disabled = q >= max;
    if (!quiet) { shown = Infinity; draw(true); }   // a tap ends the intro — the crate follows the shopper
  }

  jars.forEach(function (li) {
    var t = li.querySelector('[data-nhp-toggle]');
    if (t) t.addEventListener('click', function () { setQty(li, qty(li) > 0 ? 0 : 1); });
    [].forEach.call(li.querySelectorAll('[data-nhp-step]'), function (b) {
      b.addEventListener('click', function () { setQty(li, qty(li) + Number(b.getAttribute('data-nhp-step'))); });
    });
    setQty(li, qty(li), true);
  });

  /* the intro: the first time the crate is well in view, the picks drop in one by one */
  if (!reduce && 'IntersectionObserver' in window) {
    draw(false);
    new IntersectionObserver(function (e, obs) {
      if (!e[0].isIntersecting) return;
      obs.disconnect();
      var step = function () {
        if (shown === Infinity) return;          // the shopper already took over
        shown++;
        draw(true);
        if (shown < units().length) setTimeout(step, 240);
        else shown = Infinity;
      };
      setTimeout(step, 250);
    }, { threshold: 0.6 }).observe(crate);
  } else {
    shown = Infinity;
    draw(false);
  }

  /* the cart changed somewhere else — the stamp follows it */
  document.addEventListener('nhp:cart', function (e) {
    if (e.detail && e.detail.total_price != null) { inCart = e.detail.total_price; draw(false); }
  });

  /* ---- add ---- */
  function add() {
    if (busy) return;
    var items = jars.filter(function (li) { return qty(li) > 0; })
      .map(function (li) { return { id: Number(li.getAttribute('data-id')), quantity: qty(li) }; });
    if (!items.length) return;
    busy = true;
    btn.disabled = true;
    if (barBtn) barBtn.disabled = true;
    var label = btn.textContent;
    btn.textContent = 'ADDING…';
    if (window.NNCart && NNCart.open) NNCart.open();   // the cart opens first, then fills
    fetch((window.Shopify && Shopify.routes && Shopify.routes.root || '/') + 'cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ items: items })
    })
      .then(function (r) { return r.json().then(function (j) { if (!r.ok) throw j; return j; }); })
      .then(function () {
        btn.textContent = 'ADDED ✓';
        /* they're in the cart now — the shelf empties so nothing is counted twice */
        jars.forEach(function (li) { setQty(li, 0, true); });
        if (window.NNCart && NNCart.refresh) NNCart.refresh();
        setTimeout(function () { busy = false; draw(false); }, 1800);
      })
      .catch(function (err) {
        /* Shopify's own words (e.g. a stock limit) — never invented */
        btn.textContent = (err && err.description) ? String(err.description).toUpperCase() : 'TRY AGAIN';
        setTimeout(function () { busy = false; btn.textContent = label; draw(false); }, 2600);
      });
  }
  btn.addEventListener('click', add);
  if (barBtn) barBtn.addEventListener('click', add);

  /* ---- phones: the pinned bar, while the jars are on screen and the crate's button isn't ---- */
  if (bar && 'IntersectionObserver' in window && matchMedia('(max-width: 1023px)').matches) {
    var jarsOn = false, btnOn = false;
    var sync = function () {
      var on = jarsOn && !btnOn;
      bar.classList.toggle('is-on', on);
      if (on) bar.removeAttribute('inert'); else bar.setAttribute('inert', '');
      html.classList.toggle('nhp-coll-bar-on', on);
    };
    new IntersectionObserver(function (e) { jarsOn = e[0].isIntersecting; sync(); }).observe(root.querySelector('.nhp-coll__jars'));
    new IntersectionObserver(function (e) { btnOn = e[0].isIntersecting; sync(); }).observe(btn);
  }
})();
